import React from "react";
import { BarChart2, MessageSquare, Sparkles } from "lucide-react";
import {
  authorInitials,
  channelLabel,
  formatReportWhen,
  queueSubline,
} from "../achQueueHelpers";

function BodyTypeIcon({ type }) {
  if (type === "poll") return <BarChart2 size={11} strokeWidth={2.4} aria-hidden />;
  if (type === "bond_wheel") return <Sparkles size={11} strokeWidth={2.4} aria-hidden />;
  return <MessageSquare size={11} strokeWidth={2.4} aria-hidden />;
}

export default function ReportedMessageRow({
  item,
  rank,
  selected,
  onSelect,
  heatPct,
}) {
  const author = item?.author;
  const banned = Boolean(author?.isBanned);
  const initials = authorInitials(author?.name);
  const hasReason = Boolean(String(item?.reportReason || "").trim());

  return (
    <button
      type="button"
      className={`amf-row ach-queue-row${selected ? " amf-row-selected" : ""}${
        banned ? " amf-row-action" : ""
      }${hasReason ? " ach-queue-row-flagged" : ""}`}
      onClick={() => onSelect(item)}
      aria-pressed={selected}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct}%` }}
        title="Report recency"
        aria-hidden
      />
      <span className="amf-row-rank tabular-nums">{String(rank).padStart(2, "0")}</span>
      <span className="ach-row-avatar" aria-hidden>
        <span className="ach-row-avatar-mark">{initials}</span>
        <span className="ach-row-avatar-type">
          <BodyTypeIcon type={item?.body?.type} />
        </span>
      </span>
      <span className="amf-row-body ach-row-body">
        <span className="amf-row-top ach-row-top">
          <span className="amf-row-name" title={author?.name || "Unknown sender"}>
            {author?.name || "Unknown sender"}
          </span>
          <span className={`ach-row-channel ach-row-channel-${item.channel}`}>
            {channelLabel(item.channel)}
          </span>
          {banned ? <span className="amf-row-tag amf-row-tag-warn">Banned</span> : null}
          {hasReason ? <span className="amf-row-tag ach-row-tag-flag">Flagged</span> : null}
        </span>
        <span className="amf-row-sub ach-row-sub" title={item?.body?.text}>
          {queueSubline(item)}
        </span>
        <span className="ach-row-meta">
          <span className="ach-row-time tabular-nums">{formatReportWhen(item.reportedAt)}</span>
          {author?.email ? (
            <span className="ach-row-email" title={author.email}>{author.email}</span>
          ) : null}
        </span>
      </span>
    </button>
  );
}
